import { Channel } from "@anycable/web"
import { EventAsyncPricePercentageChanged, EventPriceChanged, EventPricePercentageChanged } from "../events";

export default class PChannel extends Channel {
  static identifier = 'PChannel'

  static setupChannel(cable) {
    // Retrieve list of coin ids that need live updating, signalled by data-coin-id with price target.
    const targets = [...document.querySelectorAll("[data-target='price.price'][data-coin-id], [data-price-target='price'][data-coin-id]")];
    const coinIds = new Set(targets.map(node => Number(node.getAttribute("data-coin-id"))));

    coinIds.forEach(coinId => cable.subscribe(new PChannel({ m: coinId })));
  }

  receive(message) {
    const coinId = message.c;
    const priceBTC = message.p;
    const priceChangePercentage24H = message.e;

    window.dispatchEvent(new CustomEvent(EventPricePercentageChanged, { detail: { priceChangePercentage24H, coinId }}));
    window.dispatchEvent(new CustomEvent(EventAsyncPricePercentageChanged, { detail: { priceChangePercentage24H, coinId }}));
    window.dispatchEvent(new CustomEvent(EventPriceChanged, { detail: { priceBTC, coinId }}));

    super.receive(message)
  }
}
